import { render } from "./customizeColumnModal.vue?vue&type=template&id=24bd285b&scoped=true"
import script from "./customizeColumnModal.vue?vue&type=script&lang=js"
export * from "./customizeColumnModal.vue?vue&type=script&lang=js"

import "./customizeColumnModal.vue?vue&type=style&index=0&id=24bd285b&lang=less&scoped=true"
import "./customizeColumnModal.vue?vue&type=style&index=1&id=24bd285b&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bd285b"]])

export default __exports__